module.exports = __webpack_public_path__ + "static/img/wallpaper-mb6.76cf74e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-mb6.jpg
// module id = jpcW
// module chunks = 1